import { c as _c } from "react/compiler-runtime";
import type { CreditCardOffer } from '@cc-shopping/contracts/cross-site/marketplace/types';
import { Typography } from '@mui/material';
export const IntroApr = t0 => {
  const $ = _c(3);
  const {
    creditCardOffer
  } = t0;
  const {
    details: t1
  } = creditCardOffer;
  const {
    apr: t2
  } = t1;
  const {
    introMessageOptions
  } = t2;
  const {
    short
  } = introMessageOptions;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      fontSize: "inherit"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const t4 = short || "N/A";
  let t5;
  if ($[1] !== t4) {
    t5 = <Typography sx={t3}>{t4}</Typography>;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  return t5;
};